exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v_base_table_with_border {\n  border: solid 1px;\n}\n.v_base_table_fill_width {\n  width: 50%;\n}\n.v_base_td_category_text {\n  background: #cccccc;\n}\n.v-data-table {\n  overflow: hidden;\n}\n", ""]);

// exports
